import { Explicacao, type ChaveComAjuda } from '../../components/Explicacao'
import type { Indicador } from '../../types/chamado'

/**
 * O glossário de cada uma das seis siglas do ANEXO VIII, num lugar só.
 *
 * As siglas aparecem cruas em várias telas — no cartão do indicador, no julgamento do chamado, no
 * fechamento — e a explicação de cada uma já estava escrita no glossário sem nunca chegar a
 * ninguém. Este mapa é o que liga o código do indicador que a API manda à entrada certa.
 */
const TERMO_DO_INDICADOR: Record<Indicador, ChaveComAjuda> = {
  ICA: 'ica',
  IAP: 'iap',
  IAE: 'iae',
  IAD: 'iad',
  TIS: 'tis',
  IIE: 'iie',
}

/**
 * A explicação de uma sigla de indicador.
 *
 * @param props o código do indicador
 * @returns a interrogação com a explicação
 */
export function ExplicacaoDoIndicador({ codigo }: { codigo: Indicador }) {
  return <Explicacao termo={TERMO_DO_INDICADOR[codigo]} />
}
